import { initContract } from "@ts-rest/core";
import { z } from "zod";
import { Account } from "../types/domains/accounting/account";
import { ReportWithNestedGroupsRowLine } from "../types/reports/types";
import { ReportingTabCycle } from "../constants";
import { TransactionClassFilterType } from "../helpers/transactions";

const c = initContract();

export interface ExtendedAccount extends Account {
    debit: number;
    credit: number;
    balance: number;
}

export interface ChartOfAccountsResponse {
    accounts: ExtendedAccount[];
}

export interface TrialBalancePeriod {
    label: string;
    dateStart: string;
    dateEnd: string;
}
export interface TrialBalanceResponse {
    periods: TrialBalancePeriod[];
    rows: ReportWithNestedGroupsRowLine[];
}

const accountingReportQuery = z.object({
    startDate: z.string(),
    endDate: z.string(),
    entityId: z.string(),
    cycle: z.nativeEnum(ReportingTabCycle),
    class: z.array(z.string()).optional(),
    classFilterType: z.nativeEnum(TransactionClassFilterType).optional(),
});

export const accountingReportsContract = c.router(
    {
        getChartOfAccounts: {
            method: "GET",
            path: "/chart-of-accounts/:entityId",
            responses: {
                200: c.type<ChartOfAccountsResponse>(),
            },
        },
        getTrialBalance: {
            method: "GET",
            path: "/trial-balance",
            query: accountingReportQuery,
            responses: {
                200: c.type<TrialBalanceResponse>(),
            },
        },
    },
    {
        pathPrefix: "/accounting-reports",
    },
);
